var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "field" },
    [
      !_vm.maskEnabled
        ? _c(
            "input",
            _vm._b(
              {
                staticClass: "field__input",
                attrs: {
                  type: _vm.type,
                  name: _vm.name,
                  id: _vm.name,
                  autocomplete: "off"
                },
                domProps: { value: _vm.value },
                on: {
                  input: function($event) {
                    return _vm.$emit("input", $event.target.value)
                  }
                }
              },
              "input",
              _vm.$attrs,
              false
            )
          )
        : _vm._e(),
      _vm.maskEnabled
        ? _c("the-mask", {
            staticClass: "field__input",
            attrs: {
              mask: ["+38(0##)###-##-##"],
              masked: false,
              value: _vm.value
            },
            on: {
              input: function(value) {
                return _vm.$emit("input", "+380" + value)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fec555fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fec555fc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/_UI/BaseField.vue
// module id = D2hL
// module chunks = 13